import React from "react";
import NumberFormat from "react-number-format";
import { Trad } from "../../components/";

interface INumberFormatProps {
    inputRef: (instance: NumberFormat | null) => void;
    onChange: (event: { currentTarget: { id: string; value: string } }) => void;
    id: string;
}

export const _NumberFormat: React.FC<INumberFormatProps> = ({ inputRef, onChange, id, ...other }) => {
    const numberSeparator = Trad.NumberSeparator();

    return (
        <NumberFormat
            {...other}
            id={id}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    currentTarget: {
                        id: id,
                        value: values.value
                    }
                });
            }}
            thousandSeparator={numberSeparator.Thousand}
            decimalSeparator={numberSeparator.Decimal}
            decimalScale={2}
            fixedDecimalScale
            isNumericString
        />
    );
};



// WEBPACK FOOTER //
// ./src/inar2/form/NumberFormat.tsx